<template>
  <div>
    <pre>{{ displayValue }}</pre>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  object: {
    type: Object
  },
  field: {
    type: Object
  }
})

const displayValue = computed(() => {
  const val = props.object[props.field.table_show || props.field.id]
  const str = typeof val === 'string' ? val : JSON.stringify(val, null, 2)
  const lines = str.split('\n')
  if (lines[0]?.trim() === '{' && lines[lines.length - 1]?.trim() === '}') {
    const inner = lines.slice(1, -1)
    const indent = inner[0]?.match(/^(\s+)/)?.[1]?.length ?? 0
    return inner.map(l => l.slice(indent)).join('\n')
  }
  return str
})
</script>

<style scoped lang="scss">
pre {
  margin-bottom: 0;
  font-family: inherit;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>
